import { Alert } from "antd";
import { Question } from "survey-core";

export class ViewQuestionModel extends Question {
  getType() {
    return "view";
  }
}

interface ViewQuestionProps {
  question: ViewQuestionModel;
}

interface Component {
  key: string;
  type: "text" | "alert";
  value: string;
}

export const ViewQuestion = ({ question }: ViewQuestionProps) => {
  const configuration = question.value as Component;

  if (!configuration || !configuration.type || !configuration.value) {
    return null;
  }

  if (configuration.type === "text" && configuration.value) {
    return <p>{configuration.value}</p>;
  }
  if (configuration.type === "alert" && configuration.value) {
    return <Alert title={configuration.value} />;
  }
};
